import type { DtcEntry } from "@strtmn/j1939"
import { toHex } from "@strtmn/strtmn"
import {
  dtcSpnLookupMapEvertiFeed,
  dtcSpnLookupMapPrimus,
  type LookupEntry,
} from "../data/dtcs-spns-de"

const lookupMaps = {
  eVertiFeed: dtcSpnLookupMapEvertiFeed,
  Primus: dtcSpnLookupMapPrimus,
}
export type ProductGroup = keyof typeof lookupMaps

export const useDtcSpnLookup = (
  productGroup: ProductGroup | null,
  fehler: DtcEntry
): LookupEntry => {
  if (fehler.SPNName) {
    return {
      category: "n/a",
      text: fehler.SPNName,
    }
  }
  if (!productGroup) {
    return {
      category: "n/a",
      text: "SPN:" + toHex(fehler.SPN, 6),
    }
  }
  const lookup = lookupMaps[productGroup][fehler.SPN]
  if (lookup) {
    return lookup
  }
  return {
    category: "n/a",
    text: "unbekannte SPN:" + toHex(fehler.SPN, 6),
  }
}
